// extracted by mini-css-extract-plugin
export default {"contents":"MI-z","sectionHeading":"NI-z"};